module.exports = __webpack_public_path__ + "assets/img/index_process.5a8e1f81.png";